// extracted by mini-css-extract-plugin
export var animationContainer = "_fj-0";
export var footer = "_fj-1";
export var gray = "_fj-2";
export var lineItem = "_fj-3";
export var lineItemImage = "_fj-4";
export var lineItemInfo = "_fj-5";
export var lineItemText = "_fj-6";
export var lineItems = "_fj-7";
export var modalContent = "_fj-8";
export var options = "_fj-9";
export var orderName = "_fj-a";
export var refundAmount = "_fj-b";